import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent implements OnInit, OnDestroy {
  @Output() finished = new EventEmitter<void>();

  isDone = false;

  private mainTimer?: ReturnType<typeof setTimeout>;
  private finishTimer?: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    this.mainTimer = setTimeout(() => {
      this.isDone = true;

      this.finishTimer = setTimeout(() => {
        this.finished.emit();
      }, 250);
    }, 750);
  }

  ngOnDestroy(): void {
    if (this.mainTimer) clearTimeout(this.mainTimer);
    if (this.finishTimer) clearTimeout(this.finishTimer);
  }
}
